import { formatValue } from './format-value.js';
import type { ChartUnit } from '../types/chart-unit.js';

/**
 * As we introduced custom formatters in the charts, we need to fallback
 * to a default function in case it's not specified by the users.
 * @param unit - Optional. The unit to be used in this formatter
 * @param precision - Optional. The precision to be used in this formatter
 *
 * @returns a default formatter (a function callback)
 */
export function defaultUnitFormatter(unit?: ChartUnit, precision?: number) {
  return (value: number, unitOverride?: ChartUnit) =>
    formatValue(value, unitOverride ? unitOverride : unit, precision);
}
